import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
  AlertDialog as AxAlertDialog,
  AlertDialogHeader,
  AlertDialogBody,
  Dialog,
  DialogBody,
  Grid,
  GridCell,
  Icon,
  Paragraph,
  ProgressButton,
  Pictogram,
  List,
  ListItem,
  Separator,
  Text
} from '@brandwatch/axiom-components';

import './AlertDialog.css';

const LinkSeparator = ({pictogram = 'web-url'}) => {
  let SelectedComponent;
  if (pictogram === 'web-url') {
    SelectedComponent = Pictogram;
  } else {
    SelectedComponent = Icon;
  }
  return (
    <Grid className="LinkSeparator__Container" responsive={false}>
      <GridCell className="LinkSeparator__Lines">
        <Separator />
      </GridCell>
      <GridCell shrink>
        <SelectedComponent name={pictogram} size="1.5rem" />
      </GridCell>
      <GridCell className="LinkSeparator__Lines">
        <Separator />
      </GridCell>
    </Grid>
  );
};

LinkSeparator.propTypes = {
  pictogram: PropTypes.oneOf(['web-url', 'exclude'])
};

const templates = {
  invite_open_error() {
    return (
      <React.Fragment>
        <Paragraph>
          There was a problem opening this Invite. Common reasons for this can include:
        </Paragraph>
        <List>
          <ListItem>This content has been deleted.</ListItem>
          <ListItem>Sharing of this content has been disabled.</ListItem>
          <ListItem>Your access to this content has been revoked.</ListItem>
          <ListItem>Temporary connection or platform instability.</ListItem>
        </List>
      </React.Fragment>
    );
  },
  invite_request_dialog(props) {
    return (
      <React.Fragment>
        <Paragraph>
          We can send one to: {props.obfuscatedData.email}
        </Paragraph>
        <LinkSeparator />
        <Paragraph>
          <ProgressButton
            disabled={props.isReinviting}
            isInProgress={props.isReinviting}
            onClick={() => props.reinvite(props.inviteId)}>
              Send Email Now
          </ProgressButton>
        </Paragraph>
      </React.Fragment>
    );
  },
  invite_sent_dialog(props) {
    return (
      <React.Fragment>
        <LinkSeparator />
        <Grid direction="row" verticalAlign="middle" horizontalAlign="middle" horizontalGutters="tiny" shrink>
          <GridCell>
            <Text textSize="body">No luck?</Text>
          </GridCell>
          <GridCell>
            <ProgressButton
              onClick={() => props.reinvite(props.inviteId)}
              disabled={props.isReinviting}
              isInProgress={props.isReinviting}
              variant="secondary">
                Resend Email
            </ProgressButton>
          </GridCell>
        </Grid>
      </React.Fragment>
    );
  },
  invite_suspended_dialog() {
    return (
      <React.Fragment>
        <LinkSeparator pictogram="exclude"/>
        <Paragraph textColor="subtle">
          Check back soon.
        </Paragraph>
      </React.Fragment>
    );
  }
};

templates.invite_request_dialog.propTypes = {
  obfuscatedData: PropTypes.object,
  inviteId: PropTypes.string,
  reinvite: PropTypes.func,
  isReinviting: PropTypes.bool,
};

templates.invite_sent_dialog.propTypes = {
  obfuscatedData: PropTypes.object,
  inviteId: PropTypes.string,
  reinvite: PropTypes.func,
  isReinviting: PropTypes.bool,
};

class AlertDialog extends Component {
  render() {
    const {
      type,
      header,
      body,
      template,
      isOpen,
      onRequestClose,
    } = this.props;

    const dialogBody = templates[template] && templates[template](this.props) || body || header;

    if (type === 'dialog') {
      return (
        <Dialog isOpen={isOpen} onRequestClose={() => {}} width="448px">
          <DialogBody>
            <Grid horizontalAlign="middle" direction="column" horizontalGutters="tiny">
              <GridCell textCenter={true}>
                <Text textStrong textSize="headtitle">{header}</Text>
              </GridCell>
              <GridCell textCenter={true}>
                {dialogBody}
              </GridCell>
            </Grid>
          </DialogBody>
        </Dialog>
      );
    }

    return (
      <AxAlertDialog overlayTheme="night" theme="night" type={type} isOpen={isOpen} onRequestClose={onRequestClose}>
        <AlertDialogHeader>{header}</AlertDialogHeader>
        <AlertDialogBody>{dialogBody}</AlertDialogBody>
      </AxAlertDialog>
    );
  }
}

AlertDialog.defaultProps = {
  header: '',
  isOpen: false,
};

AlertDialog.propTypes = {
  type: PropTypes.string,
  header: PropTypes.string,
  body: PropTypes.string,
  template: PropTypes.string,
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
};

export default AlertDialog;
